<app-floating-visor style="position: absolute; user-select: none; z-index: 120; height: 0px;" [width]="previewSizeW"
  [height]="previewSize" [left]="previewLeft" [top]="60" [showWindowingTool]="showWindowingTool"
  (addLastStep)="addLastStep()" (closeVisor)="showMenu()">
</app-floating-visor>

<div class="w-100 h-100 d-flex justify-content-center align-items-center"
  style="position:absolute;top:0;left:0; z-index: 999; background-color: rgba(139, 139, 139, 0.486);"
  *ngIf='showSpinner'>
  <div class="spinner-border text-light" role="status">
  </div>
  <span class="ms-3">Loading...</span>
</div>

<app-side-options-desktop *ngIf="!isPageSmall" [caducityTime]="caducityTime!" [token]="token"
  (onClickRenew)="refreshCaducity()" (onClickShare)="openShareModal($event)" (initDesktopTour)="startDesktopTour()"
  (stepBackToVisor)="this.viewers.first.openVisor()"></app-side-options-desktop>

<!-- <app-side-options-mobile *ngIf="isPageSmall" [caducityTime]="caducityTime"></app-side-options-mobile> -->

<div
  style="position: absolute; left: 30px;width: 500px; top:150px;font-size: 36px; display: flex;justify-content: center;"
  *ngIf="pageNumber==0 && !isPageSmall" [innerHTML]="bookName">
</div>

<!-- Botón de descargar informe en la versión móvil -->

<!-- HEADER PARA EL LANDSCAPE -->
<div *ngIf="isPageSmall">
  <app-header *ngIf="!visorOpen" [token]="token" (initHorizontalTour)="startHorizontalMobileTour()"
    (sendMail)="sendMail($event)"></app-header>
</div>
<!--<div style="position: absolute;left: 6px;top: 45%; z-index: 999;" *ngIf="isPageSmall">
  <div class="share-icon-container clickable" style="position: relative; bottom: 0;" (click)='openReport()'>
    <span>
      <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
        <path fill="white"
          d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z" />
      </svg>
    </span>
  </div>
  <div class="text-golden"><small>{{'REPORT' | translate}}</small></div>
</div>

<div style="position: absolute;left: 6px;top: 10%; z-index: 999;" *ngIf="isPageSmall">
  <div class="share-icon-container clickable" style="position: relative; bottom: 0;" (click)='showHelp()'>
    <span>

      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28.3332 15.0001C28.3332 12.7899 27.4552 10.6703 25.8924 9.10752C24.3296 7.54472 22.21 6.66675 19.9998 6.66675C17.7897 6.66675 15.6701 7.54472 14.1073 9.10752C12.5445 10.6703 11.6665 12.7899 11.6665 15.0001C11.6665 15.4421 11.8421 15.866 12.1547 16.1786C12.4672 16.4912 12.8911 16.6667 13.3332 16.6667C13.7752 16.6667 14.1991 16.4912 14.5117 16.1786C14.8242 15.866 14.9998 15.4421 14.9998 15.0001C14.9998 14.0112 15.2931 13.0445 15.8425 12.2222C16.3919 11.4 17.1728 10.7591 18.0864 10.3807C19 10.0022 20.0054 9.90323 20.9753 10.0962C21.9452 10.2891 22.8361 10.7653 23.5354 11.4645C24.2346 12.1638 24.7108 13.0547 24.9038 14.0246C25.0967 14.9945 24.9977 15.9999 24.6192 16.9135C24.2408 17.8271 23.5999 18.608 22.7777 19.1574C21.9554 19.7068 20.9887 20.0001 19.9998 20.0001C19.5578 20.0001 19.1339 20.1757 18.8213 20.4882C18.5088 20.8008 18.3332 21.2247 18.3332 21.6667V25.0001C18.3332 25.4421 18.5088 25.866 18.8213 26.1786C19.1339 26.4912 19.5578 26.6667 19.9998 26.6667C20.4419 26.6667 20.8658 26.4912 21.1783 26.1786C21.4909 25.866 21.6665 25.4421 21.6665 25.0001V23.1667C23.5488 22.7825 25.2405 21.7598 26.4553 20.2716C27.6702 18.7834 28.3336 16.9212 28.3332 15.0001Z"
          fill="url(#paint0_linear_400_1738)" />
        <path
          d="M20.0002 33.3333C20.9206 33.3333 21.6668 32.5871 21.6668 31.6667C21.6668 30.7462 20.9206 30 20.0002 30C19.0797 30 18.3335 30.7462 18.3335 31.6667C18.3335 32.5871 19.0797 33.3333 20.0002 33.3333Z"
          fill="url(#paint1_linear_400_1738)" />
        <defs>
          <linearGradient id="paint0_linear_400_1738" x1="13.7573" y1="10.406" x2="28.0467" y2="20.3292"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#D79314" />
            <stop offset="0.5" stop-color="#FDDA98" />
            <stop offset="1" stop-color="#D79314" />
          </linearGradient>
          <linearGradient id="paint1_linear_400_1738" x1="18.7517" y1="30.6232" x2="21.2517" y2="32.7065"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#D79314" />
            <stop offset="0.5" stop-color="#FDDA98" />
            <stop offset="1" stop-color="#D79314" />
          </linearGradient>
        </defs>
      </svg>

    </span>
  </div>
  <div class="text-golden"><small>TOUR</small></div>
</div>-->

<!-- ACABA EL HEADER PARA EL LANDSCAPE -->

<div id="reportContainer" class="report-container" (mouseup)="resetDeltas()"
  *ngIf="reportService.actualReport!=undefined"
  style="max-height: calc(100% - 53px); max-width: 33%; width: auto; position: absolute; top: 53px;border-radius: 8px;"
  [@showReport]="calculateShowReportAnimation()"
  [ngStyle]="{width:reportService.actualReport.type=='pdf' || reportService.activatedAI ? '33%' : 'auto', overflow: reportService.actualReport.type=='html' ? 'hidden' : (reportService.activatedAI) ? 'visible' : 'auto', boxShadow: reportService.actualReport.type=='html' ? '2px 2px 16px #73a5f060' : 'none'}">

  <div *ngIf="!this.tourService.guideTour.isActive() && !reportService.activatedAI">
    <button type="button" class="round-button more-zoom" *ngIf=" !isPageSmall" (click)='increaseZoom()'>
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.3779 8.34092H9.85016V3.81321C9.85016 3.61308 9.77066 3.42113 9.62914 3.27962C9.48762 3.1381 9.29568 3.05859 9.09554 3.05859C8.8954 3.05859 8.70346 3.1381 8.56195 3.27962C8.42043 3.42113 8.34092 3.61308 8.34092 3.81321V8.34092H3.81321C3.61308 8.34092 3.42113 8.42043 3.27962 8.56195C3.1381 8.70346 3.05859 8.8954 3.05859 9.09554C3.05859 9.29568 3.1381 9.48762 3.27962 9.62914C3.42113 9.77066 3.61308 9.85016 3.81321 9.85016H8.34092V14.3779C8.34092 14.578 8.42043 14.7699 8.56195 14.9115C8.70346 15.053 8.8954 15.1325 9.09554 15.1325C9.29568 15.1325 9.48762 15.053 9.62914 14.9115C9.77066 14.7699 9.85016 14.578 9.85016 14.3779V9.85016H14.3779C14.578 9.85016 14.7699 9.77066 14.9115 9.62914C15.053 9.48762 15.1325 9.29568 15.1325 9.09554C15.1325 8.8954 15.053 8.70346 14.9115 8.56195C14.7699 8.42043 14.578 8.34092 14.3779 8.34092Z"
          fill="#E2E7F4" />
      </svg>
    </button>
    <button type="button" class="round-button less-zoom" *ngIf=" !isPageSmall" (click)='decreaseZoom()'>
      <svg width="19" height="19" viewBox="0 0 19 19" fill="white" xmlns="http://www.w3.org/2000/svg">
        <line x1="4" y1="9.5" x2="15" y2="9.5" stroke="white" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
    <!--<button type="button" class="round-button print" *ngIf=" !isPageSmall"
      (click)='studiesService.downloadReport(bookService.currentBook!.studyUIDs)' title="Descargar informe">
      <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 0V7.5H2.5L10 15L17.5 7.5H12.5V0H7.5ZM0 17.5V20H20V17.5H0Z" fill="white" />
      </svg>
    </button>-->
  </div>

  <!--<div class="print-text d-flex justify-content-center"><small>{{'MENU.DOWNLOAD' | translate}}<br>{{'REPORT' |
      translate}}</small></div>-->

  <!-- Informes PNG -->
  <div
    *ngIf="reportService.actualReport!=undefined && reportService.actualReport.type=='png' && !reportService.activatedAI"
    style="background-color: white;padding: 5px;border-right: 1px solid black;width: 100%;height: 100%;">
    <div id="externalReportDiv" class="reportDiv" style="height: 100%; overflow: auto; background-color: white;">
      <div style="display: inline-block; position: relative; background-color: white;" class='book-image-container'
        [style.height.%]="flipbookHeight" [style.width.%]="flipbookHeight">
        <img draggable="false" [src]="reportService.actualReport.data">
      </div>
    </div>
  </div>

  <!-- Informes PDF -->
  <div class="p-relative h-100 w-100"
    *ngIf="reportService.actualReport!=undefined && reportService.actualReport.type=='pdf' && !reportService.activatedAI">
    <pdf-viewer [src]="reportService.actualReport.data" [render-text]="true" [original-size]="false" [zoom]="pdfZoom"
      [render-text-mode]="2" style="width: 100%; height: 100%"></pdf-viewer>
  </div>


  <!-- Informes html -->
  <div class="w-100 h-100 p-4" style="background-color: white; color: black !important; overflow: auto;"
    *ngIf="reportService.actualReport!=undefined && reportService.actualReport.type=='html' && !reportService.activatedAI"
    [style.fontSize]="reportFontSize + 'px'" [innerHTML]="reportService.actualReport.data">
  </div>

  <!-- Informes IA -->
  <div class="w-100 h-100 p-4 ai-report" *ngIf="reportService.actualReport!=undefined && reportService.activatedAI"
    [style.fontSize]="reportFontSize + 'px'">
    <app-ai-report></app-ai-report>
  </div>

  <button type="button" *ngIf="reportService.hasPrev() && !isPageSmall" class="btn btn-primary change-page"
    style="left: calc(50% - 50px);" (click)='reportService.prevReport()'>
    &lt;
  </button>
  <span *ngIf="reportService.reports.length > 1 && !isPageSmall && !reportService.activatedAI" class="report-index">
    {{reportService.reportIndex + 1}} / {{reportService.reports.length}}
  </span>
  <button type="button" *ngIf="reportService.hasNext() && !isPageSmall" class="btn btn-primary change-page"
    style="left: calc(50% + 50px);" (click)='reportService.nextReport()'>
    &gt;
  </button>

  <div class="clickable" style="position: absolute; top: 10px; right: 10px; display: flex; align-items: center;"
    *ngIf="!reportService.activatedAI && reportService.aiData!=null" (click)="reportService.activatedAI = true">
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28 0C26.632 4.944 24.87 6.633 20 8C24.87 9.367 26.632 11.056 28 16C29.368 11.056 31.13 9.367 36 8C31.13 6.633 29.368 4.944 28 0ZM14 8C11.605 16.651 8.524 19.608 0 22C8.524 24.392 11.605 27.349 14 36C16.395 27.349 19.476 24.392 28 22C19.476 19.608 16.395 16.651 14 8Z"
        fill="#F1C250" />
    </svg>
    <span style="color: #F1C250; font-size: 34px; margin-left: 5px;">IA</span>
  </div>
  <!-- <span class="clickable underline" style="position: absolute; bottom: 10px; left: 20%; color: #004cff;" *ngIf="!reportService.activatedAI && reportService.aiData!=null"
  (click)="reportService.activatedAI = true">Potenciar con Inteligencia Artificial</span> -->
</div>

<div id="flipbookContainer" class="container-fluid h-100 w-100" (mouseup)="resetDeltas()">
  <!-- Header -->
  <div class="row g-0 p-2" style="height: 53px;" *ngIf="!globalVariables.isPageSmall">
    <div class="col d-flex justify-content-between">
      <img src="assets/img/Logo Vertical.svg" class="clickable" height="40px"
        (click)="(company==Company.DEBRAIN) ? window.location.href='http://www.debrain-he.com/products?product=DIGITALBOOK' : window.location.href='http://www.m3meuropa.com/products?product=DIGITALBOOK'">
      <span style="font-size: 20px;color:#f2c63d">{{"HEADER.TITLE" | translate}}</span>
      

      <!--  ESTO ES PARA EL PORTAL PACIENTE DEMO -->

      <div class="d-flex justify-content-end align-items-center">
        <span class="me-2" style="cursor: pointer; z-index: 1;" *ngIf="environment.demo">
          <svg (click)="expandedIndex=true" *ngIf="!expandedIndex" xmlns="http://www.w3.org/2000/svg" height="22px"
            viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
          </svg>
          <svg (click)="expandedIndex=false" *ngIf="expandedIndex" xmlns="http://www.w3.org/2000/svg" height="22px"
            viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
          </svg>
        </span>
        <span class='prp-icons icon-m3m-logo clickable' *ngIf="company==Company.M3M"
          style="font-size: 18px; color:turquoise !important;" height="18"
          (click)="window.location.href='http://www.m3meuropa.com'"></span>
          <span class='ps-icons icon-debrain clickable' *ngIf="company==Company.DEBRAIN"
        style="font-size: 14px; color:turquoise !important;" height="12"
        (click)="window.location.href='http://www.debrain-he.com'"></span>
      </div>

      <!--<span class='prp-icons icon-m3m-logo clickable' *ngIf="company==Company.M3M"
        style="font-size: 18px; color:turquoise !important;" height="18"
        (click)="window.location.href='http://www.m3meuropa.com'"></span>-->


    </div>
  </div>
  <div class="clickable" style="position: absolute;right: 240px;top: 10px;" (click)="toggleBookMode()"
    *ngIf="!isPageSmall">
    <span style="margin-right: 10px;"
      [ngStyle]="{color: (permissionService.bookMode=='patient') ? '#f2c63d' : 'white'}">
      {{'HEADER.PATIENT_MODE' | translate}}
    </span>
    <!-- Rounded switch -->
    <label class="switch" (click)="$event.preventDefault()">
      <span class="slider round" [ngClass]="{checked: permissionService.bookMode=='prescriptor'}"></span>
      <input type="checkbox">
      <!-- [checked]="permissionService.bookMode=='prescriptor'"> -->
    </label>
    <span style="margin-left: 10px;"
      [ngStyle]="{color: (permissionService.bookMode=='prescriptor') ? '#f2c63d' : 'white'}">
      {{'HEADER.DOCTOR_MODE' | translate}}
    </span>
  </div>

  <!-- Book -->
  <div id="bookRow" class="row g-0"
    [ngStyle]="{maxHeight:(globalVariables.isPageSmall) ? 'calc(100%)' : 'calc(100% - 53px)'}"
    *ngIf="bookService.currentBook!=null">
    <div class="col-12 h-100" id="wrapper" [ngClass]='{wrapper:flipbookLoaded}'
      [ngStyle]="{visibility: flipbookLoaded ? 'visible' : 'hidden'}">

      <div class="new-card tip" *ngIf="!isPageSmall" style="transition: 1s;"
        [ngStyle]="{opacity: (isShowingCover) ? '1' : '0'}">
        <span class="text-golden">
          {{'TIPS.TIP_1' | translate}}
        </span>
      </div>

      <!-- <button *ngIf="isPageSmall" (click)='download()' class="btn btn-primary disabled"
        style="position: absolute; bottom:40px; left: 1px">
        {{(downloading!=null) ? (downloading==0) ? 'Preparando...' : downloading+'%' : 'Descargar'}}
      </button>
      <button *ngIf="isPageSmall" (click)='openShareModal()' class="btn btn-primary"
        style="position: absolute; bottom:5px; left: 1px">
        Compartir
      </button> -->

      <div id="flipbook" [@centerBook]="calculateCenterBookAnimation()">
        <div class="page report-container" *ngFor='let page of bookService.currentBook.pages'
          [ngClass]="{transparent: isReportTransparent(page)}">
          <div style="background-color: white;padding: 5px;border-right: 1px solid black;width: 100%;height: 100%;">
            <div id="internalReportDiv" style="height: 100%;" [ngClass]="{reportDiv:page.type == BookPageType.REPORT}"
              [ngStyle]="{overflow: (flipbookHeight>100 && page.type == BookPageType.REPORT) ? 'auto' : 'hidden', backgroundColor: (page.type == BookPageType.IMAGES) ? 'black' : 'white'}">
              <div *ngFor='let img of page.bookImages' style="display: inline-block; position: relative;"
                (click)="(page.type == BookPageType.IMAGES && img.dicomFile && (permissionService.hasPermission(TokenPermissions.OPEN_IMAGE_PREVIEW) || isPageSmall)) ? openPreview(img, $event) : (page.type == BookPageType.REPORT) ? openReport() : null"
                [ngClass]="{clickable:img.dicomFile!=null && img.dicomFile!='' && permissionService.hasPermission(TokenPermissions.OPEN_IMAGE_PREVIEW)}"
                class='book-image-container'
                [style.height.%]="(page.type == BookPageType.REPORT) ? flipbookHeight : img.height"
                [style.width.%]="(page.type == BookPageType.REPORT) ? flipbookHeight : img.width"
                [style.borderColor]="(page.type == BookPageType.IMAGES && img.isKo) ? '#f2c63d08' : ''">
                <div class="w-100 h-100" style="position:absolute;top:0;left:0; transition: 0.5s;"
                  [ngStyle]="{backgroundColor: (img.pngFile == auxDemoPngFile) ? '#f2c53d4d': 'transparent'}"></div>
                <img draggable="false" [src]="imagesService.getImage(img.pngFile)" *ngIf="img.mp4File==null">
                <video draggable="false" class="multiframe-video" muted
                  *ngIf="img.mp4File!=null && imagesService.getSingleImage(img.mp4File)!=null"
                  style="width: 100%;height: 100%;" autoplay loop>
                  <source [src]="imagesService.getSingleImage(img.mp4File)" type="video/mp4">
                  Your browser does not support the video.
                </video>
                <span *ngIf="img.type == BookImageType.SERIES && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">serie</span>
                <span *ngIf="img.type == BookImageType.CINE && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">cine</span>
                <span *ngIf="img.type == BookImageType.GRID && img.dicomFile"
                  style="position: absolute;top: 4px;left: 4px;">grid</span>
                <div *ngIf="page.type == BookPageType.IMAGES && img.isKo"
                  style="position: absolute;top: 2px;left: 4px;color: #f2c53de0">
                  <span *ngIf='isPageSmall' class='d-block' style="font-size: small;">KO</span>
                  <span *ngIf='!isPageSmall' class='d-block' style="font-size: small;">Imagen</span>
                  <span *ngIf='!isPageSmall' class='d-block' style="font-size: small;">Clave</span>
                </div>
                <div *ngIf="img.description!=null" class="text-golden"
                  style="position: absolute;bottom: 10px;width: 100%;text-align: center">{{img.description}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<app-animations></app-animations>
<!--<app-download-instructions></app-download-instructions>-->
<app-share-study (sendMail)="sendMail($event)" (downloadReport)="downloadReport()"></app-share-study>
<!--<app-download-modal></app-download-modal>-->

<!--  ESTO ES PARA PORTAL MODEL DEMO -->
<div class="index" [ngClass]="{'expanded': expandedIndex}">
  <!-- *ngIf="expandedIndex"  [ngStyle]="{'height': 'calc(40px * ' + (indexMenuList.length +1) +')', 'transition': 'height 2s'}">-->

  <div *ngFor="let list of indexMenuList">

    <div class="index-item" (click)="redirectTo(list.url)" *ngIf="list.url != null">
      <span class="text-golden">
        {{list.name}}
      </span>
    </div>

    <div class="index-item" (mouseover)='toggleDigitalBookIndex()' (mouseout)="closeDigitalBookIndexWithDelay()" *ngIf="list.url == null">
    <span class="me-2" style="cursor: pointer; rotate: -90deg;">
      <svg (click)="expandedDigitalBookIndex=true" *ngIf="!expandedDigitalBookIndex" xmlns="http://www.w3.org/2000/svg" height="22px"
        viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
      </svg>
      <svg (click)="expandedDigitalBookIndex=false" *ngIf="expandedDigitalBookIndex" xmlns="http://www.w3.org/2000/svg" height="22px"
        viewBox="0 0 24 24" width="24px" fill="#FFFFFF">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
      </svg>
    </span>
    <span class="text-golden" >
      {{list.name}}
    </span>
    
  </div>

  </div>
  
</div>

<div class="digitalBookindex" (mouseover)='keepMenuOpen()' (mouseout)="closeDigitalBookIndexWithDelay()" [ngClass]="{'expanded': expandedDigitalBookIndex}"> 
  <!-- *ngIf="expandedDigitalBookIndex" [ngStyle]="{'height': 'calc(40px * ' + (indexDigitalBook.length +1) +')', 'transition': '0.5s;'}" -->


  <div *ngFor="let book of indexDigitalBook">

    <div class="index-item" (click)="redirectTo(book.url)">
          
      <span class="text-golden">
        {{book.name}}
      </span>
    </div>

  </div>

</div>